import { createAsyncThunk } from '@reduxjs/toolkit';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { BookingReducerProps } from '../type';
import { bookingApiService } from '@services/service-register';

export const fetchBookingSetting = createAsyncThunk(
  'booking/fetchBookingSetting',
  async (_, thunkApi) => {
    try {
      const bookingSetting = await bookingApiService.getBookingSetting();
      return bookingSetting;
    } catch (e: any) {
      return undefined;
    }
  }
);

const [fulfilled, pending, rejected] = getSideEffectState(fetchBookingSetting);

export const fetchBookingSettingReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
    state.bookingSetting = action.payload;
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
    state.bookingSetting = null;
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<BookingReducerProps>;
